export default __webpack_public_path__ + "static/index_hero_03-b426a977adafc7f806b4d1bd5856c4c4.jpg";